export default __webpack_public_path__ + "static/media/automatskavrata.8f04d1a9.png";